module.exports = __webpack_public_path__ + "img/9.17a6ab83.png";